import { supabase } from './supabase';

// Subscribe to changes on a table filtered by user
export function subscribeToDuels(profileId: string, onChange: (payload: any) => void) {
  return supabase.channel(`duels:${profileId}`)
    .on('postgres_changes', {
      event: '*',
      schema: 'public',
      table: 'duels',
      filter: `challenger_id=eq.${profileId}`,
    }, onChange)
    .on('postgres_changes', {
      event: '*',
      schema: 'public',
      table: 'duels',
      filter: `challenged_id=eq.${profileId}`,
    }, onChange)
    .subscribe();
}

export function subscribeToFeed(gymId: string | null, onChange: (payload: any) => void) {
  const channel = supabase.channel(`feed:${gymId || 'global'}`);
  if (gymId) {
    channel.on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'posts', filter: `gym_id=eq.${gymId}` }, onChange);
  } else {
    channel.on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'posts' }, onChange);
  }
  return channel.subscribe();
}

export function subscribeToTournamentMatches(tournamentId: string, onChange: (payload: any) => void) {
  return supabase.channel(`tournament:${tournamentId}`)
    .on('postgres_changes', { event: '*', schema: 'public', table: 'tournament_matches', filter: `tournament_id=eq.${tournamentId}` }, onChange)
    .subscribe();
}
